import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IDocument } from "../../interfaces/document";
import moment from "moment";

interface IDocumentSliceInitialState {
  pageNumber: string;
  pageSize: number;
  selectedStatus: string;
  selectedDateRange: IDateRange;
  selectedMetros: string[];
  isAllSelected: boolean;
  metros: any[];
}

interface IDateRange {
  fromDate: string | null; toDate: string | null;
}

export const documentInitialState: IDocumentSliceInitialState = {
  pageNumber: "1",
  pageSize: 20,
  selectedStatus: "",
  selectedDateRange: {
    fromDate: moment().subtract(1, 'days').startOf('day').toString(), 
    toDate: moment().endOf('day').toString()
  },
  selectedMetros: [],
  isAllSelected: true,
  metros: []
};

export const documentSlice = createSlice({
  name: "document",
  initialState: documentInitialState,
  reducers: {
    setPageNumberForDocument: ( state: IDocumentSliceInitialState, { payload }: PayloadAction<string> ) => {
      state.pageNumber = payload;
    },
    setPageSizeForDocument: (state: IDocumentSliceInitialState, { payload }: PayloadAction<number>) => {
      state.pageSize = payload;
    },
    setSelectedDateRange: (state: IDocumentSliceInitialState, { payload }: PayloadAction<IDateRange>) => {
      state.selectedDateRange = payload;
    },
    setSelectedMetros: (state: IDocumentSliceInitialState, { payload }: PayloadAction<string[]>) => {
      state.selectedMetros = payload;
    },
    setIsAllSelected: (state: IDocumentSliceInitialState, { payload }: PayloadAction<boolean>) => {
      state.isAllSelected = payload;
    },
    setMetros: (state: IDocumentSliceInitialState, { payload }: PayloadAction<any[]>) => {
      state.metros = payload;
    },
    setSelectedStatus: (state: IDocumentSliceInitialState, { payload }: PayloadAction<string>) => {
      state.selectedStatus = payload;
    },
  },
});

export const { setPageNumberForDocument, setPageSizeForDocument, setSelectedStatus, setSelectedMetros, setIsAllSelected, setSelectedDateRange, setMetros } =
  documentSlice.actions;
export default documentSlice.reducer;
